<template>
  <power-wrapper :CurrRole="CurrRole">
    <div class="distributorList">
      <div class="topLeft">
        <h3>精品课订单<span class="time" v-if="updateTime">数据更新时间：{{ timestampToDate(updateTime) }}</span></h3>
        <div class="refresh">&nbsp;</div>
      </div>
      <div class="topRight">
        <div>管理员能看到所有成员的订单<br />普通成员只能看到自己的和无归属人的订单</div>
      </div>
      <div class="statistics" v-if="statisticsArr.length > 0">
        <li class="card" v-for="(item, index) in statisticsArr" :key='index'>
          <div class="date">{{ item.label }}
            <el-tooltip v-if="item.show" class="item" effect="dark" placement="top-start">
              <div slot="content" style="line-height:18px">
                1-订单集合，按照支付时间统计，包括已支付和已退费，不包括未支付。<br />
                2-管理员角色时，包括团队所有成员的订单。<br />
                3-普通成员角色时，只包括归属人是自己的订单，不包括无归属人订单。
              </div>
              <i class="el-icon-info"></i>
            </el-tooltip>
          </div>
          <div class="sum">{{ item.type === 'money' ? numberFormatRgx2(item.number) : numberFormat(item.number) }}</div>
        </li>
      </div>
      <el-form :inline="true" :model="listQuery" label-width="100px">
        <el-form-item label="支付状态">
          <el-select v-model="listQuery.order_status" placeholder="请选择支付状态">
            <el-option v-for="item in allOrderStatu" :key="item.value" :label="item.name" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="listQuery.payType" placeholder="请选择支付时间">
            <el-option v-for="item in allTime" :key="item.value" :label="item.name" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker v-model="createTime" value-format="timestamp" type="daterange" :picker-options="pickerOptions"
            @blur="enableChoose" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
            style="width:235px"></el-date-picker>
        </el-form-item>
        <el-form-item label="课程科目" label-width="80px">
          <SubjectCascader :onChange="subjectCascaderChange" />
        </el-form-item>
        <el-form-item label="推广课程">
          <el-select v-model="listQuery.promotion_course_id" multiple filterable placeholder="请选择推广课程">
            <el-option label="全部推广课程" value="all" />
            <el-option v-for="item in courseList" :key="item.id" :label="item.agentCourse.name"
              :value="item.agentCourse.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="推广渠道">
          <el-select v-model="listQuery.promotion_channel_id" filterable placeholder="请选择推广渠道" @change="handleChannel">
            <el-option label="全部推广渠道" :value="null" />
            <el-option v-for="item in channelList" :key="item.id" :label="item.name" :value="item.promotionChannelCode" />
          </el-select>
        </el-form-item>
        <el-form-item label="推广位">
          <el-select v-model="listQuery.promotion_position_id" filterable placeholder="请选择推广位">
            <el-option label="全部推广位" :value="null" />
            <el-option v-for="item in promotionList" :key="item.id" :label="item.name"
              :value="item.promotionPositionCode" />
          </el-select>
        </el-form-item>
        <el-form-item label="归属人">
          <el-select v-model="listQuery.member_id" filterable placeholder="请选择归属人">
            <el-option label="全部归属人" :value="null" />
            <el-option v-for="item in teamList" :key="item.id" :label="item.name" :value="item.agentCode" />
          </el-select>
        </el-form-item>
        <el-form-item label="微信昵称">
          <el-input v-model="listQuery.wx_name" placeholder="输入微信昵称查询" class="orderStyle" />
        </el-form-item>
        <el-form-item label="用户ID">
          <el-input v-model="listQuery.user_id" placeholder="输入用户ID查询" class="orderStyle numrule" maxlength="13"
            autocomplete="on" @input="checkUserIdLength" @keyup.native="checkUserIdNumber" />
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input type="number" v-model="listQuery.phone" placeholder="输入手机号查询" class="orderStyle numrule"
            maxlength="11" autocomplete="on" @input="checkLength" @keyup.native="checkPhoneNumber" />
        </el-form-item>
        <el-form-item label="体验课开课日期" label-width="120px">
          <el-date-picker v-model="listQuery.class_open_time" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="体验课学期ID" label-width="120px">
          <el-select v-model="listQuery.term_id" value-key="id" multiple filterable clearable placeholder="请选择学期">
            <el-option label="全部" value='all' />
            <el-option v-for="item in termList" :key="item.id" :label="`${item.id}·${item.name}(${item.description})`"
              :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="公益课学期名称" label-width="140px" v-if="conversionPath">
          <el-select v-model="listQuery.b2c_term_id" filterable multiple clearable placeholder="请选择公益课学期">
            <el-option v-for="item in b2cTermList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="学习进度">
          <el-select v-model="listQuery.studyProgress" filterable placeholder="请选择学习进度">
            <el-option :key="0" label="全部" value='' />
            <el-option :key="1" label="首课未开课" value="1" />
            <el-option :key="2" label="首课已开课" value="2" />
            <el-option :key="3" label="续报未截止" value="3" />
            <el-option :key="4" label="续报已截止" value="4" />
          </el-select>
        </el-form-item>
        <el-form-item label="推广链接ID">
          <el-input v-model="listQuery.promotion_link_id" placeholder="输入推广链接ID查询" class="orderStyle" />
        </el-form-item>
        <el-form-item label="是否重复购买体验课" label-width="140px" v-if="repeatBuy">
          <el-select v-model="listQuery.is_repeat_buy" filterable placeholder="全部">
            <el-option :key="0" label="全部" value='' />
            <el-option :key="1" label="是" :value="1" />
            <el-option :key="2" label="否" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input v-model="listQuery.order_no" placeholder="输入订单号查询" class="orderStyle" />
        </el-form-item>
        <el-form-item>
          <span class="item-span">
            <el-tooltip class="item" effect="dark" placement="bottom-start">
              <div slot="content" style="line-height:18px">
                指从精品课下单时间起，多长时间内发生退费的订单
              </div>
              <i class="el-icon-question"></i>
            </el-tooltip>
            退费周期
          </span>
          <el-input v-model="listQuery.refund_cycle" placeholder="1-90" max="90" min="1" class="item-input-day"
            type="number" />
          <span class="item-span">天内</span>
        </el-form-item>
        <el-button class="filter-item" type="primary" @click="handleSearch">查询</el-button>
        <!-- 下载组建 -->
        <DownExcel :listQuery="listQuery" :createTime="createTime" :total="total" :getListQuery="getListQuery"
          pageType="official" />
      </el-form>
      <div class="refresh">在查询条件下：总订单数<strong>{{ orderSun.paid_order_num }}</strong>笔，总支付金额<strong>{{ orderSun.pay_amount
      }}</strong>元;总退费订单数<strong>{{ orderSun.refund_order_num }}</strong>笔，总退费金额<strong>{{ orderSun.refund_amount
}}</strong>元</div>
      <el-table v-loading="listLoading" :data="list" :empty-text="emptyText" border fit highlight-current-row
        style="width: 100%" :header-cell-style="tableHeader">
        <el-table-column label="支付时间" align="center" width="160">
          <template slot-scope="{row}">
            <span>{{ row.pay_time || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="公益课学期ID" align="center" width="160" v-if="conversionPath">
          <template slot-scope="{row}">
            <span>{{ row.b2c_term_id || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="公益课学期名称" align="center" width="160" v-if="conversionPath">
          <template slot-scope="{row}">
            <span>{{ row.b2c_term_name || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="体验课学期" align="center" width="160">
          <template slot-scope="{row}">
            <span>{{ row.term_id || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="体验课学期名称" align="center" width="160">
          <template slot-scope="{row}">
            <span>{{ row.term_name || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付金额" align="center" min-width="90">
          <template slot-scope="{row}">
            <span>{{ row.order_amount ? numberFormatRgx2(row.order_amount) : '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="退款金额" align="center" min-width="90">
          <template slot-scope="{row}">
            <span>{{ row.refund_amount ? numberFormatRgx2(row.refund_amount) : '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="微信头像" align="center" width="80">
          <template slot-scope="{row}">
            <img :src="row.wx_avater || '//wxlogo.hetao101.com/default_avatar.png'" alt="avatar" class="avatar" />
          </template>
        </el-table-column>
        <el-table-column label="微信昵称" align="center" min-width="100">
          <template slot-scope="{row}">
            <span>{{ row.wx_name || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="首课进度" align="center" min-width="100">
          <template slot-scope="{row}">
            <span>{{ row.is_unlock === 1 ? '首课未开课' : row.is_unlock === 0 ? '首课已开课' : '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="体验课开课日期" align="center" min-width="120">
          <template slot-scope="{row}">
            <span>{{ row.class_open_time || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="续报进度" align="center" min-width="100">
          <template slot-scope="{row}">
            <span>{{ row.is_renewal === 1 ? '续报未截止' : row.is_renewal === 0 ? '续报已截止' : '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付状态" align="center">
          <template slot-scope="{row}">
            <span>{{ handleStatus(row.order_status) || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否重复购买体验课" align="center" min-width="150" v-if="repeatBuy">
          <template slot-scope="{row}">
            <span>{{ (row.is_repeat_buy ? '是' : '否') || '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="用户ID" align="center" min-width="100">
          <template slot-scope="{row}">
            <span>{{ row.user_id || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="课程科目" align="center" min-width="100">
          <template slot-scope="{row}">
            <span>{{ row.subject_type || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="推广课程" align="center" min-width="140">
          <template slot-scope="{row}">
            <span>{{ row.promotion_course_name || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="推广课程ID" align="center" min-width="120">
          <template slot-scope="{row}">
            <span>{{ row.promotion_course_id || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单号" align="center" min-width="140">
          <template slot-scope="{row}">
            <span>{{ row.order_no || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="体验课支付时间" align="center" min-width="140">
          <template slot-scope="{row}">
            <span>{{ row.l1_pay_time || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="精品课退费时间" align="center" min-width="140">
          <template slot-scope="{row}">
            <span>{{ row.refund_time || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="退费周期" align="center" min-width="140">
          <template slot-scope="{row}">
            <span>{{ row.refund_cycle || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="归属人" align="center">
          <template slot-scope="{row}">
            <span>{{ row.member_name || '无归属人' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="推广链接ID" align="center" width="120">
          <template slot-scope="{row}">
            <span>{{ row.promotion_link_id || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="推广渠道" width="180px">
          <template slot-scope="{row}">
            <el-tooltip class="item" effect="dark" :content="row.promotion_channel_name" placement="top">
              <span>{{ row.promotion_channel_name && row.promotion_channel_name.length > 10 ?
                `${row.promotion_channel_name.slice(0, 10)}...` : row.promotion_channel_name || '--' }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="推广位" align="center" min-width="140">
          <template slot-scope="{row}">
            <span>{{ row.promotion_position_name || '--' }}</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total > 0" :total="total" :page.sync="listQuery.index" :limit.sync="listQuery.pageSize"
        @pagination="getList" />
    </div>
  </power-wrapper>
</template>

<script>
import Cookie from 'js-cookie';
import { mapGetters } from 'vuex'
import DownExcel from "@/components/DownExcel/index";
import PowerWrapper from "@/components/PowerWrapper";
import Pagination from "@/components/Pagination/index";
import SubjectCascader from "@/components/SubjectCascader";

import { getTermListNew } from "@/services/term";
import { getPromotionList } from "@/services/promotion";
import { apiGetB2CTermsList } from "@/services/b2cStatement";
import { getChannelList, getTeamList } from "@/services/link";
import { getStarOrder, getOrderAcc, getCourseList, getOrderSum } from "@/services/order";

import { getAgentCode, getTeamCode, getTeamRole, getConversionPath } from '@/utils/auth'
import { timestampToDate, delUndefined, numFormat, formatNumberRgx2, timestampToDateTotal } from '@/utils/utils';

export default {
  name: "official",
  components: {
    Pagination,
    PowerWrapper,
    DownExcel,
    SubjectCascader
  },
  data() {
    return {
      CurrRole: "official",
      list: [],
      b2cTermList: [],
      termList: [], // 学期array
      emptyText: '暂无数据',
      listQuery: {
        term_id: null,
        index: 1,
        pageSize: 10,
        subject_type: '',
        class_open_time: '',
        order_status: null,
        payType: 'l1PayTime',
        promotion_course_id: [],
        promotion_channel_id: null,
        promotion_position_id: null,
        promotion_user_id: (Number(getTeamRole()) === 1 || Number(getTeamRole()) === 2) ? null : getAgentCode(),
        wx_name: null,
        order_number: null,
        studyProgress: null,
        promotion_link_id: null,
        is_repeat_buy: '',
        b2c_term_id: '',
        mobile: null,
        user_id: null,
      },
      orderSun: {
        paid_order_num: 0,
        pay_amount: 0,
        refund_amount: 0,
        refund_order_num: 0
      },
      createTime: [new Date().getTime() - 3600 * 1000 * 24 * 30, new Date().getTime()],
      pickerMinDate: "", // 第一次选中的时间
      pickerOptions: {
        shortcuts: [
          {
            text: "今日",
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().setHours(0, 0, 0, 0));
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "昨日",
            onClick(picker) {
              const start = new Date();
              start.setTime(start.getTime() - 24 * 60 * 60 * 1000);
              start.setHours(0, 0, 0, 0);
              const end = new Date();
              end.setTime(end.getTime() - 24 * 60 * 60 * 1000);
              end.setHours(23, 59, 59, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              const end = new Date();
              const week = end.getDay();
              const millisecond = 1000 * 60 * 60 * 24;
              const minusDay = week !== 0 ? week - 1 : 6;
              const monday = new Date(end.getTime() - minusDay * millisecond);
              const start = new Date(monday);
              start.setHours(0, 0, 0, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上周",
            onClick(picker) {
              // 上周开始时间
              const starta = new Date();
              var first = starta.getDate() - starta.getDay() - 6;
              var startDate = new Date(starta.setDate(first));
              const start = new Date(startDate);
              start.setHours(0, 0, 0, 0);
              //  上周结束时间
              var currentDate = new Date();
              var firsts = currentDate.getDate() - currentDate.getDay() - 6;
              var last = firsts + 6;
              var endDate = new Date(currentDate.setDate(last));
              const end = new Date(endDate);
              end.setHours(23, 59, 59, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本月",
            onClick(picker) {
              const currentDate = new Date();
              const currentMonth = currentDate.getMonth();
              const currentYear = currentDate.getFullYear();
              const start = new Date(currentYear, currentMonth, 1);
              const end = new Date();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上月",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              const m = start.getMonth() - 1;
              start.setDate(1);
              start.setMonth(m);
              end.setDate(0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        onPick: obj => {
          this.pickerMinDate = new Date(obj.minDate).getTime();
        },
        // disabledDate: time => {
        //   if (this.pickerMinDate) {
        //     const day1 = 93 * 24 * 3600 * 1000;
        //     const maxTime = this.pickerMinDate + day1;
        //     const minTime = this.pickerMinDate - day1;
        //     return time.getTime() > maxTime || time.getTime() < minTime;
        //   }
        // }
      },
      total: 1,
      allOrderStatu: [
        {
          value: null,
          name: '全部支付状态'
        },
        {
          value: 'PAID',
          name: '已支付'
        },
        {
          value: 'UNPAID',
          name: '未支付'
        },
        {
          value: 'REFUND',
          name: '已退费'
        }
      ],
      allTime: [
        {
          value: 'l1PayTime',
          name: '体验课支付时间'
        },
        {
          value: 'payTime',
          name: '精品课支付时间'
        },
        {
          value: 'refundTime',
          name: '精品课退费时间'
        }
      ],
      listLoading: false,
      statisticsArr: [],
      courseList: [],
      channelList: [],
      promotionList: [],
      teamList: [],
      updateTime: null,
      dialogVisible: false
    };
  },
  computed: {
    tableHeader() {
      return { 'background-color': '#f5f5f5' }
    },
    conversionPath() {
      return getConversionPath() && Number(getConversionPath()) === 2
    },
    ...mapGetters([
      'repeatBuy'
    ]),
  },
  created() {
    this.getList()
    // 统计接口
    this.getStatistics()
    // 获取推广课程
    this.getCourseList()
    // 获取推广渠道
    this.getChannelList()
    // 获取团队成员信息
    this.getTeamList()
    // 获取学期列表
    this.getTermList()
    // 获取B2C学期列表
    this.getB2CTermsList()
  },
  methods: {
    subjectCascaderChange(subject_type) {
      this.listQuery.subject_type = subject_type;
    },
    enableChoose() {
      this.pickerMinDate = null
    },
    getB2CTermsList() {
      apiGetB2CTermsList().then(res => {
        this.b2cTermList = res?.data?.data || [];
      }).catch((error) => {
        console.log(error)
      })
    },
    handleStatus(value) {
      return value ? value === 'UNPAID' ? '未支付' : value === 'PAID' ? '已支付' : value === 'REFUND' ? '已退费' : '' : null
    },
    numberFormat(num) {
      return numFormat(num)
    },
    numberFormatRgx2(num) {
      return formatNumberRgx2(num)
    },
    timestampToDate(time) {
      return timestampToDateTotal(time)
    },
    getStatistics() {
      const params = {
        index: 1,
        pageSize: 1,
        stat_day: timestampToDate(Date.parse(new Date()))
      }
      getOrderAcc(delUndefined(params)).then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          const orderList = res.data.data;
          if (orderList && orderList.length > 0) {
            const accObj = orderList[0];
            this.updateTime = accObj.load_time || null;
            this.statisticsArr = [
              { label: '昨日订单量', number: accObj.today_order_cnt || 0, show: true, type: 'amount' },
              { label: '本月订单量', number: accObj.current_month_order_cnt || 0, show: false, type: 'amount' },
              { label: '本月支付金额', number: accObj.current_month_order_amount || 0, show: false, type: 'money' },
              { label: '累计支付金额', number: accObj.total_order_amount || 0, show: false, type: 'money' }
            ]
          }
        } else if (res.data && res.data.errCode === 1016) {
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.statisticsArr = [];
        }
      });
    },
    getListQuery(btnName) {
      let { listQuery, createTime = [] } = this;
      const _listQuery = Object.assign({}, listQuery);
      const { payType, index } = _listQuery;
      createTime = createTime || [];
      const [startTime = null, endTime = null] = createTime;
      const times = {};
      Object.keys(_listQuery).forEach(key => {
        const query = _listQuery[key];
        if (key !== 'subject_type' && Array.isArray(query)) {
          Object.assign(_listQuery, {
            [key]: query.indexOf('all') > -1 ? null : query.join(',')
          })
        }
      });
      switch (payType) {
        case 'payTime':
          Object.assign(times, {
            start_pay_time: timestampToDate(startTime),
            end_pay_time: timestampToDate(endTime),
          })
          break;
        case 'l1PayTime':
          Object.assign(times, {
            l1_start_pay_time: timestampToDate(startTime),
            l1_end_pay_time: timestampToDate(endTime),
          })
          break;
        case 'refundTime':
          Object.assign(times, {
            start_refund_time: timestampToDate(startTime),
            end_refund_time: timestampToDate(endTime),
          })
          break;
        default:
          break;
      }
      const params = {
        ..._listQuery,
        ...times,
        index: btnName === 'search' ? 1 : index,
        orderColumn: 'order_time',
        orderType: 'desc'
      }
      delete params.payType;
      return params;
    },
    getList(btnName) {
      this.listLoading = true;
      const params = this.getListQuery(btnName);
      const opts = {
        type: 'POST',
        params: {
          ...delUndefined(params)
        }
      }
      getStarOrder(opts).then((res = {}) => {
        const { errCode, errMsg, data, total } = res.data || {};
        if (errCode === 0 && Array.isArray(data) && data.length > 0) {
          this.listLoading = false;
          this.list = data;
          this.total = total;
          if (btnName === 'search') {
            this.listQuery.index = 1;
          }
        } else if (errCode === 1016) {
          this.$message({ type: 'error', message: '登录时效已过期，请重新登录' })
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.emptyText = errMsg && errMsg !== 'success' ? errMsg : '暂无数据';
          this.listLoading = false;
          this.list = [];
          this.total = 0;
        }
      });
      getOrderSum(opts).then((res = {}) => {
        const { errCode, errMsg, data } = res.data || {};
        let orderSunInfo
        if (errCode === 0 && data) {
          orderSunInfo = data;
        } else {
          console.log('getOrderSum error - ', res);
          this.$message({ type: 'error', message: errMsg });
          orderSunInfo = {
            paid_order_num: 0,
            pay_amount: 0,
            refund_amount: 0,
            refund_order_num: 0
          }
        }
        this.orderSun = orderSunInfo
      })
    },
    getPromotionList(promotion_channel_id) {
      const params = {
        teamCode: getTeamCode(),
        channelCode: promotion_channel_id
      }
      getPromotionList(delUndefined(params)).then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          this.promotionList = res.data.data;
        } else if (res.data && res.data.errCode === 1016) {
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.promotionList = [];
        }
      });
    },
    getTeamList() {
      const params = {
        teamCode: getTeamCode()
      }
      getTeamList(delUndefined(params)).then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          let teamArr = []
          // 角色身份
          if (Number(getTeamRole()) === 1 || Number(getTeamRole()) === 2) {
            teamArr = [
              {
                agentCode: 0,
                name: '无归属人'
              }
            ]
            this.teamList = teamArr.concat(res.data.data);
          } else {
            teamArr = [
              {
                agentCode: getAgentCode(),
                name: '我的'
              },
              {
                agentCode: 0,
                name: '无归属人'
              }
            ]
            this.teamList = teamArr;
          }
        } else if (res.data && res.data.errCode === 1016) {
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.teamList = [];
        }
      });
    },
    getCourseList() {
      getCourseList().then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          this.courseList = res.data.data.list;
        } else if (res.data && res.data.errCode === 1016) {
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.courseList = [];
        }
      });
    },
    getChannelList() {
      const teamCode = getTeamCode()
      getChannelList(teamCode).then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          this.channelList = res.data.data;
        } else if (res.data && res.data.errCode === 1016) {
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.channelList = [];
        }
      });
    },
    handleChannel(value) {
      this.promotion_channel_id = value;
      this.listQuery.promotion_position_id = null;
      if (value) {
        this.getPromotionList(value)
      } else {
        this.promotionList = [];
      }
    },
    handleSearch() {
      this.getList('search');
    },
    getTermList() {
      getTermListNew().then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          this.termList = res.data.data;
        } else {
          this.termList = [];
        }
      });
    },
    checkLength(e) {
      if (e.length > 11) {
        this.listQuery.mobile = e.slice(0, 11)
      }
    },
    checkPhoneNumber() {
      const regNum = /[^\d]/g;
      this.listQuery.mobile = this.listQuery.mobile && regNum.test(this.listQuery.mobile) ? this.listQuery.mobile.toString().replace(/[^\d]/g, '') : this.listQuery.mobile;
    },
    checkUserIdLength(e) {
      if (e.length > 13) {
        this.listQuery.user_id = e.slice(0, 13)
      }
    },
    checkUserIdNumber() {
      const regNum = /[^\d]/g;
      this.listQuery.user_id = this.listQuery.user_id && regNum.test(this.listQuery.user_id) ? this.listQuery.user_id.toString().replace(/[^\d]/g, '') : this.listQuery.user_id;
    }
  }
};
</script>

<style lang="less" scoped>
@import '../../styles/common.less';

.item-span {
  display: inline-block;
  padding: 0 12px;
}

.item-input-day {
  width: 80px;
}

.topRight {
  line-height: 22px;
}
</style>
